import React, { Fragment, useEffect, useState } from 'react'
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import {
    agregarFC_01AnexoUnidadAlmacen, editarFC_01AnexoUnidadAlmacen,
    eliminarFC_01AnexoAlmacenMap,
    agregarFC_01AnexoUnidadAlmacenMap,
    obtenerSeccionesAlmacen,
    agregarDataSeccionesAlmacen,
    editarEquipoAlmacen,
    eliminarDataElementoBD,
    eliminarResponsableBD,
    actualizarFC_01NumeroDeUnidades,
    editarFC_01AnexoInstalacion,
    agregarFC_01AnexoInstalacion,
    obtenerFC_01Map, setModoCorreccion, obtenerFC_01SolicitudDetalleConFiles,
    actualizarInstalaciones
} from '../../../redux/DucksBeneficiario/FC_01Ducks'
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import estilos from './FormularioFC01Anexos.module.css'; { {/*Estilos para el componente*/ } }
import Tooltip from '@mui/material/Tooltip';
import ModalComponent from '../../App/ModalComponent'
import GuardarInstalacionComponent from './GuardarInstalacionComponent';
import { obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosConClaveApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerMunicipiosConClavePorEstadoApi, setCallesApi, setCodigosPostalesApi, setColoniasApi, setLocalidadesApi, setMunicipiosApi } from '../../../redux/DucksApis/CopomexDucks';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FormularioFC01AnexoAlmacenBeneficiarioComponent(props) {

    const dispatch = useDispatch()
    var fechaHoy = moment().format('YYYY-MM-DD');
    let idEditable = 0
    const [editInstalacion, setEditInstalacion] = useState(false)
    if (props.history.location.state) {
        idEditable = props.history.location.state.idEdit
    }
    React.useEffect(() => {
        if (props.history.location.state.idEdit) setEditInstalacion(true)
    }, [])

    let anexoAlmacenEditable = useSelector(store => store.FC_01Solicitud.instalaciones).filter(anexo => anexo.data.id === idEditable)

    const anexoAlmacenFormato = useSelector(store => store.AtencionSolicitud.formato?.fc_01_anexounidaddealmacen)?.filter(anexo => anexo.id === idEditable)
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)
    const anexoMap = useSelector(store => store.FC_01Solicitud.anexoUnidadMap)
    const anexoResponsablesMap = useSelector(store => store.FC_01Solicitud.anexoResponsableMap)
    const seccionesAlmacen = useSelector(store => store.FC_01Solicitud.seccionesAlmacen)
    let dataFC_01 = useSelector(store => store.FC_01Solicitud.actividadesEmpresa)
    let data = useSelector(store => store.FC_01Solicitud.data)
    let domicilioFiscal = useSelector(store => store.FC_01Solicitud.domicilioFiscal)
    const numeroDeUnidades = useSelector(store => store.FC_01Solicitud.numeroDeUnidades)

    //Municipios y estados validos
    const estadosDenominacionOrigen = useSelector(store => store.FC_01Solicitud.estadosDenominacionOrigen)
    const estadosDenominacion = useSelector(store => store.FC_01Solicitud.estadosDenominacion)
    const municipiosTamaulipas = useSelector(store => store.FC_01Solicitud.municipiosTamaulipas)
    const municipiosGuanajuato = useSelector(store => store.FC_01Solicitud.municipiosGuanajuato)
    const municipiosMichoacan = useSelector(store => store.FC_01Solicitud.municipiosMichoacan)
    const municipiosPuebla = useSelector(store => store.FC_01Solicitud.municipiosPuebla)

    //Api domicilio
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)


    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [dictameninstalaciones, setdictameninstalaciones] = useStateIfMounted(false)
    const [actualizacioninformacion, setactualizacioninformacion] = useStateIfMounted(false)
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [fechapropuesta, setfechapropuesta] = useStateIfMounted(fechaHoy)
    const [instalacionnumero, setinstalacionnumero] = useStateIfMounted()
    const [tipoinstalacionbodega, settipoinstalacionbodega] = useStateIfMounted(false)
    const [tipoinstalacionanejamiento, settipoinstalacionanejamiento] = useStateIfMounted(false)
    const [tipoinstalacionmaduracion, settipoinstalacionmaduracion] = useStateIfMounted(false)
    const [tipoinstalaciongranel, settipoinstalaciongranel] = useStateIfMounted(false)
    const [tipoinstalacionreposado, settipoinstalacionreposado] = useStateIfMounted(false)
    const [alias, setalias] = useStateIfMounted('')
    const [calle, setcalle] = useStateIfMounted('')
    const [otracalle, setotracalle] = useStateIfMounted('')
    const [numeroexterior, setnumeroexterior] = useStateIfMounted('')
    const [numerointerior, setnumerointerior] = useStateIfMounted('')
    const [colonia, setcolonia] = useStateIfMounted('')
    const [localidad, setlocalidad] = useStateIfMounted('')
    const [municipio, setmunicipio] = useStateIfMounted('')
    const [estado, setestado] = useStateIfMounted('')
    let [codigopostal, setcodigopostal] = useStateIfMounted()
    const [referenciascercanas, setreferenciascercanas] = useStateIfMounted('')
    let [telefono, settelefono] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const [nombreresponsable, setnombreresponsable] = useStateIfMounted('')
    const [tarimas, settarimas] = useStateIfMounted(false)
    const [cantidadtarimas, setcantidadtarimas] = useStateIfMounted('')
    const [capacidadtarimas, setcapacidadtarimas] = useStateIfMounted('')
    const [patines, setpatines] = useStateIfMounted(false)
    const [cantidadpatines, setcantidadpatines] = useStateIfMounted("")
    const [capacidadpatines, setcapacidadpatines] = useStateIfMounted("")
    const [montacargas, setmontacargas] = useStateIfMounted(false)
    const [cantidadmontacargas, setcantidadmontacargas] = useStateIfMounted('')
    const [capacidadmontacargas, setcapacidadmontacargas] = useStateIfMounted('')
    const [se_alamientos, setse_alamientos] = useStateIfMounted(false)
    const [cantidadse_alamientos, setcantidadse_alamientos] = useStateIfMounted("")
    const [capacidadse_alamientos, setcapacidadse_alamientos] = useStateIfMounted("")
    const [otroproductoterminado, setotroproductoterminado] = useStateIfMounted(false)
    const [opcionproductoterminado, setopcionproductoterminado] = useStateIfMounted("")
    const [cantidadproductoterminado, setcantidadproductoterminado] = useStateIfMounted("")
    const [capacidadproductoterminado, setcapacidadproductoterminado] = useStateIfMounted("")
    const [recipientesvidrio, setrecipientesvidrio] = useStateIfMounted(false)
    const [cantidadrecipientesvidrio, setcantidadrecipientesvidrio] = useStateIfMounted('')
    const [capacidadrecipientesvidrio, setcapacidadrecipientesvidrio] = useStateIfMounted('')
    const [barricasmadera, setbarricasmadera] = useStateIfMounted(false)
    const [cantidadbarricasmadera, setcantidadbarricasmadera] = useStateIfMounted("")
    const [capacidadbarricasmadera, setcapacidadbarricasmadera] = useStateIfMounted("")
    const [controlhumedad, setcontrolhumedad] = useStateIfMounted(false)
    const [cantidadcontrolhumedad, setcantidadcontrolhumedad] = useStateIfMounted('')
    const [caracteristicascontrolhumedad, setcaracteristicascontrolhumedad] = useStateIfMounted('')
    const [controltemperatura, setcontroltemperatura] = useStateIfMounted(false)
    const [cantidadcontroltemperatura, setcantidadcontroltemperatura] = useStateIfMounted('')
    const [caracteristicascontroltemperatu, setcaracteristicascontroltemperatu] = useStateIfMounted('')
    const [otrocontrolvariables, setotrocontrolvariables] = useStateIfMounted(false)
    const [opcioncontrolvariables, setopcioncontrolvariables] = useStateIfMounted('')
    const [cantidadcontrolvariables, setcantidadcontrolvariables] = useStateIfMounted('')
    const [caracteristicascontrolvariables, setcaracteristicascontrolvariables] = useStateIfMounted('')
    const [idfc01_solicitudregistro, setidfc01_solicitudregistro] = useStateIfMounted("")
    const [idiformaciongeneral, setidiformaciongeneral] = useStateIfMounted("")
    //const [, setidiformaciongeneral] = useStateIfMounted("")

    const [isValid, setIsValid] = useStateIfMounted(false);
    const [message, setMessage] = useStateIfMounted('');


    React.useEffect(() => {
        dispatch(obtenerSeccionesAlmacen(3))
    }, [])

    const obtenerIdElemento = (data) => {
        for (const elemento of data.seccion.seccion.elementosdeseccion) {
            if (elemento.elemento.nombreelemento === data.valor) {
                return elemento.idelemento
            }
        }
        return null
    }
    //Metodos para seccion de producto terminado
    const [opcionesSeleccionadosSeccion1, setOpcionesSeleccionadosSeccion1] = useStateIfMounted([])
    const [equipoAlmacen, setEquipoAlmacen] = useStateIfMounted([])

    const deleteEquipoAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = equipoAlmacen.filter(fields => fields.id !== inputField.id)
        setEquipoAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion1(opciones)
    }
    const handleAddEquipoAlmacen = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setEquipoAlmacen([...equipoAlmacen, anexo])
    };

    const handleOnChangueEquipoAlmacen = (data) => {
        const input = equipoAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion1
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion1([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setEquipoAlmacen([...equipoAlmacen])
    }

    //Metodos para seccion de Maduracion-Añejamiento de producto 
    const [opcionesSeleccionadosSeccion2, setOpcionesSeleccionadosSeccion2] = useStateIfMounted([])
    const [maduracionAlmacen, setMaduracionAlmacen] = useStateIfMounted([])

    const deleteMaduracionAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = maduracionAlmacen.filter(fields => fields.id !== inputField.id)
        setMaduracionAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion2(opciones)
    }
    const handleAddMaduracionAlmacen = (data) => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        // data.valor = 'Recipientes de vidrio'
        // let idelemento = obtenerIdElemento(data)
        // let idseccion = data.seccion.idseccion
        setMaduracionAlmacen([...maduracionAlmacen, anexo])
        // setOpcionesSeleccionadosSeccion2([...opcionesSeleccionadosSeccion2, { nombre: data.valor }])
    };
    const handleOnChangueMaduracionAlmacen = (data) => {
        const input = maduracionAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion2
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion2([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setMaduracionAlmacen([...maduracionAlmacen])
    }
    //Metodos para seccion de añejamiento
    const [opcionesSeleccionadosSeccion5, setOpcionesSeleccionadosSeccion5] = useStateIfMounted([])
    const [anejamientoAlmacen, setAnejamientoAlmacen] = useStateIfMounted([])

    const deleteAnejamientoAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = anejamientoAlmacen.filter(fields => fields.id !== inputField.id)
        setAnejamientoAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion5(opciones)
    }
    const handleAddAnejamientoAlmacen = (data) => {
        data.valor = 'Barricas de madera'
        let idelemento = obtenerIdElemento(data)
        let idseccion = data.seccion.idseccion
        let anexo = { id: uuidv4(), opcion: data.valor, cantidad: '', descripcion: '', idelemento: idelemento, idseccion: idseccion }
        setAnejamientoAlmacen([...anejamientoAlmacen, anexo])
        setOpcionesSeleccionadosSeccion5([...opcionesSeleccionadosSeccion5, { nombre: data.valor }])
    };
    const handleOnChangueAnejamientoAlmacen = (data) => {
        const input = anejamientoAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            // let opcionesSeleccionados = opcionesSeleccionadosSeccion5
            // if (data.campo === 'opcion' && input[0].opcion !== '') {
            //     opcionesSeleccionados = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== input[0].opcion)
            // }
            input[0][data.campo] = data.valor
            // if (data.campo === 'opcion') {
            //     input[0]['idelemento'] = obtenerIdElemento(data)
            //     input[0]['idseccion'] = data.seccion.idseccion
            // }
            // setOpcionesSeleccionadosSeccion5([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setAnejamientoAlmacen([...anejamientoAlmacen])
    }


    //Metodos para seccion de control de variables
    const [opcionesSeleccionadosSeccion3, setOpcionesSeleccionadosSeccion3] = useStateIfMounted([])
    const [variablesAlmacen, setVariablesAlmacen] = useStateIfMounted([])

    const deleteVariablesAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = variablesAlmacen.filter(fields => fields.id !== inputField.id)
        setVariablesAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion3(opciones)
    }
    const handleAddVariablesAlmacen = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setVariablesAlmacen([...variablesAlmacen, anexo])
    };
    const handleOnChangueVariablesAlmacen = (data) => {
        const input = variablesAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion3
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion3([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setVariablesAlmacen([...variablesAlmacen])
    }

    //Metodos para seccion de granel
    const [opcionesSeleccionadosSeccion4, setOpcionesSeleccionadosSeccion4] = useStateIfMounted([])
    const [granelAlmacen, setGranelAlmacen] = useStateIfMounted([])

    const deleteGranelAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = granelAlmacen.filter(fields => fields.id !== inputField.id)
        setGranelAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion4(opciones)
    }
    const handleAddGranelAlmacen = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setGranelAlmacen([...granelAlmacen, anexo])
    };
    const handleOnChangueGranelAlmacen = (data) => {
        const input = granelAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion4
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion4([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setGranelAlmacen([...granelAlmacen])
    }

    //Metodos para seccion de reposado
    const [opcionesSeleccionadosSeccion6, setOpcionesSeleccionadosSeccion6] = useStateIfMounted([])
    const [reposadoAlmacen, setReposadoAlmacen] = useStateIfMounted([])

    const deleteReposadoAlmacen = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = reposadoAlmacen.filter(fields => fields.id !== inputField.id)
        setReposadoAlmacen(fields)
        const opciones = opcionesSeleccionadosSeccion6.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion6(opciones)
    }
    const handleAddReposadoAlmacen = (data) => {
        data.valor = 'Barricas de madera'
        let idelemento = obtenerIdElemento(data)
        let idseccion = data.seccion.idseccion
        let anexo = { id: uuidv4(), opcion: data.valor, cantidad: '', descripcion: '', idelemento: idelemento, idseccion: idseccion }
        setReposadoAlmacen([...reposadoAlmacen, anexo])
        setOpcionesSeleccionadosSeccion6([...opcionesSeleccionadosSeccion6, { nombre: data.valor }])
    };
    const handleOnChangueReposadoAlmacen = (data) => {
        const input = reposadoAlmacen.filter(field => field.id === data.id)
        if (input.length > 0) {
            input[0][data.campo] = data.valor
        }
        setReposadoAlmacen([...reposadoAlmacen])
    }

    //Metodos para los responsables
    const [responsables, setResponsables] = useStateIfMounted([])

    const deleteResponsable = (inputField) => {
        if (inputField.idresponsabledeinstalacion) {
            dispatch(eliminarResponsableBD(inputField.idresponsabledeinstalacion))
        }
        const fields = responsables.filter(fields => fields.id !== inputField.id)
        setResponsables(fields)
    }
    const handleAddResponsable = () => {
        let anexo = { id: uuidv4(), nombreresponsable: '', telefono: '', correoelectronico: '', estado: false }
        setResponsables([...responsables, anexo])
    };
    const handleOnChangueResponsable = (data) => {
        const input = responsables.filter(field => field.id === data.id)
        if (input.length > 0) {
            input[0][data.campo] = data.valor
            input[0][data.campo] = data.valor
            if (data.campo === 'correoelectronico') input[0]['estado'] = comprobarEmail(data.valor)
        }
        setResponsables([...responsables])
    }

    React.useEffect(async () => {

        if (anexoAlmacenEditable.length > 0) {
            const anexo = anexoAlmacenEditable[0].data
            //setactualizacioninformacion(anexo.actualizacioninformacion)
            setalias(anexo.alias)
            setbarricasmadera(anexo.barricasmadera)
            setcalle(anexo.calle)
            setcantidadbarricasmadera(anexo.cantidadbarricasmadera)
            setcantidadcontrolhumedad(anexo.cantidadcontrolhumedad)
            setcantidadcontroltemperatura(anexo.cantidadcontroltemperatura)
            setcantidadcontrolvariables(anexo.cantidadcontrolvariables)
            setcantidadmontacargas(anexo.cantidadmontacargas)
            setcantidadpatines(anexo.cantidadpatines)
            setcantidadproductoterminado(anexo.cantidadproductoterminado)
            setcantidadrecipientesvidrio(anexo.cantidadrecipientesvidrio)
            setcantidadse_alamientos(anexo.cantidadse_alamientos)
            setcantidadtarimas(anexo.cantidadtarimas)
            setcapacidadbarricasmadera(anexo.capacidadbarricasmadera)
            setcapacidadmontacargas(anexo.capacidadmontacargas)
            setcapacidadpatines(anexo.capacidadpatines)
            setcapacidadproductoterminado(anexo.capacidadproductoterminado)
            setcapacidadrecipientesvidrio(anexo.capacidadrecipientesvidrio)
            setcapacidadse_alamientos(anexo.capacidadse_alamientos)
            setcapacidadtarimas(anexo.capacidadtarimas)
            setcaracteristicascontrolhumedad(anexo.caracteristicascontrolhumedad)
            setcaracteristicascontroltemperatu(anexo.caracteristicascontroltemperatu)
            setcaracteristicascontrolvariables(anexo.caracteristicascontrolvariables)
            setcodigopostal(anexo.codigopostal)
            setcolonia(anexo.colonia)
            setcontrolhumedad(anexo.controlhumedad)
            setcontroltemperatura(anexo.controltemperatura)
            setcorreoelectronico(anexo.correoelectronico)
            setdictameninstalaciones(anexo.dictameninstalaciones)
            setestado(anexo.estado)
            setfechapropuesta(anexo.fechapropuesta)
            setfechasolicitud(anexo.fechasolicitud)
            setinstalacionnumero(anexo.instalacionnumero)
            setlocalidad(anexo.localidad)
            setmontacargas(anexo.montacargas)
            setmunicipio(anexo.municipio)
            //setnombrerazonsocial(anexo.nombrerazonsocial)
            setnombreresponsable(anexo.nombreresponsable)
            setnumeroexterior(anexo.numeroexterior)
            setnumerointerior(anexo.numerointerior)
            setopcioncontrolvariables(anexo.opcioncontrolvariables)
            setopcionproductoterminado(anexo.opcionproductoterminado)
            setotrocontrolvariables(anexo.otrocontrolvariables)
            setotroproductoterminado(anexo.otroproductoterminado)
            setpatines(anexo.patines)
            setrecipientesvidrio(anexo.recipientesvidrio)
            setreferenciascercanas(anexo.referenciascercanas)
            setse_alamientos(anexo.se_alamientos)
            settarimas(anexo.tarimas)
            // settelefono(anexo.telefono)
            settipoinstalacionbodega(anexo.tipoinstalacionbodega)
            settipoinstalacionmaduracion(anexo.tipoinstalacionmaduracion)
            settipoinstalaciongranel(anexo.tipoinstalaciongranel)
            settipoinstalacionanejamiento(anexo.tipoinstalacionanejamiento)
            settipoinstalacionreposado(anexo.tipoinstalacionreposado)
            setidfc01_solicitudregistro(anexo.idfc01_solicitudregistro)
            setidiformaciongeneral(anexo.idiformaciongeneral)
            // if (anexo.correoelectronico !== null) comprobarEmail(anexo.correoelectronico)

            if (anexo.instalaciones) {
                for (const instalacion of anexo.instalaciones) {
                    switch (instalacion.tipoinstalacion.instalacion) {
                        case 'Producto terminado':
                            settipoinstalacionbodega(true)
                            break
                        case 'Graneles':
                            settipoinstalaciongranel(true)
                            break
                        case 'Maduracion':
                            settipoinstalacionmaduracion(true)
                            break
                        // case 'Añejamiento':
                        //     settipoinstalacionanejamiento(true)
                        //     break
                        // case 'Reposado':
                        //     settipoinstalacionreposado(true)
                        //     break
                        default:
                            break
                    }
                }
            }

            if (anexo.dataSeccion) {
                let auxElementosSeccion1 = []
                for (const elemento of anexo.dataSeccion.equipoAlmacen) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion1.push(nuevoElemento)
                }
                setEquipoAlmacen(auxElementosSeccion1)

                let auxElementosSeccion2 = []
                for (const elemento of anexo.dataSeccion.maduracionAlmacen) {
                    const { opcion, cantidad, descripcion, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion2.push(nuevoElemento)
                }
                setMaduracionAlmacen(auxElementosSeccion2)

                let auxElementosSeccion3 = []
                for (const elemento of anexo.dataSeccion.variablesAlmacen) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion3.push(nuevoElemento)
                }
                setVariablesAlmacen(auxElementosSeccion3)

                let auxElementosSeccion4 = []
                for (const elemento of anexo.dataSeccion.granelAlmacen) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion4.push(nuevoElemento)
                }
                setGranelAlmacen(auxElementosSeccion4)

                let auxElementosSeccion5 = []
                for (const elemento of anexo.dataSeccion.anejamientoAlmacen) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion5.push(nuevoElemento)
                }
                setAnejamientoAlmacen(auxElementosSeccion5)

                let auxElementosSeccion6 = []
                for (const elemento of anexo.dataSeccion.reposadoAlmacen) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion6.push(nuevoElemento)
                }
                setReposadoAlmacen(auxElementosSeccion6)

                setOpcionesSeleccionadosSeccion1(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion1)
                setOpcionesSeleccionadosSeccion2(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion2)
                setOpcionesSeleccionadosSeccion3(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion3)
                setOpcionesSeleccionadosSeccion4(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion4)
                setOpcionesSeleccionadosSeccion5(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion5)
                setOpcionesSeleccionadosSeccion6(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion6)
            }
            if (anexo.responsables) {
                let auxResponsables = []
                for (const responsable of anexo.responsables) {
                    const { nombreresponsable, telefono, correoelectronico, estado, idiformaciongeneral, idresponsabledeinstalacion } = responsable
                    const nuevoResponsable = {
                        id: uuidv4(), nombreresponsable: nombreresponsable, telefono: telefono, correoelectronico: correoelectronico, estado: estado,
                        idiformaciongeneral: idiformaciongeneral, idresponsabledeinstalacion: idresponsabledeinstalacion
                    }
                    auxResponsables.push(nuevoResponsable)
                }
                setResponsables(auxResponsables)
            }
            await dispatch(actualizarLoadingApp_true())
            // const result = await obtenerEstadosConClave()
            await cargarDomicilioApi(anexo)
            await dispatch(actualizarLoadingApp_false())
        } else {
            if (anexoAlmacenFormato) {
                const anexo = anexoAlmacenFormato[0]
                setactualizacioninformacion(anexo.actualizacioninformacion)
                setalias(anexo.alias)
                setbarricasmadera(anexo.barricasmadera)
                setcalle(anexo.calle)
                setcantidadbarricasmadera(anexo.cantidadbarricasmadera)
                setcantidadcontrolhumedad(anexo.cantidadcontrolhumedad)
                setcantidadcontroltemperatura(anexo.cantidadcontroltemperatura)
                setcantidadcontrolvariables(anexo.cantidadcontrolvariables)
                setcantidadmontacargas(anexo.cantidadmontacargas)
                setcantidadpatines(anexo.cantidadpatines)
                setcantidadproductoterminado(anexo.cantidadproductoterminado)
                setcantidadrecipientesvidrio(anexo.cantidadrecipientesvidrio)
                setcantidadse_alamientos(anexo.cantidadse_alamientos)
                setcantidadtarimas(anexo.cantidadtarimas)
                setcapacidadbarricasmadera(anexo.capacidadbarricasmadera)
                setcapacidadmontacargas(anexo.capacidadmontacargas)
                setcapacidadpatines(anexo.capacidadpatines)
                setcapacidadproductoterminado(anexo.capacidadproductoterminado)
                setcapacidadrecipientesvidrio(anexo.capacidadrecipientesvidrio)
                setcapacidadse_alamientos(anexo.capacidadse_alamientos)
                setcapacidadtarimas(anexo.capacidadtarimas)
                setcaracteristicascontrolhumedad(anexo.caracteristicascontrolhumedad)
                setcaracteristicascontroltemperatu(anexo.caracteristicascontroltemperatu)
                setcaracteristicascontrolvariables(anexo.caracteristicascontrolvariables)
                setcodigopostal(anexo.codigopostal)
                setcolonia(anexo.colonia)
                setcontrolhumedad(anexo.controlhumedad)
                setcontroltemperatura(anexo.controltemperatura)
                setcorreoelectronico(anexo.correoelectronico)
                setdictameninstalaciones(anexo.dictameninstalaciones)
                setestado(anexo.estado)
                setfechapropuesta(anexo.fechapropuesta)
                setfechasolicitud(anexo.fechasolicitud)
                setinstalacionnumero(anexo.instalacionnumero)
                setlocalidad(anexo.localidad)
                setmontacargas(anexo.montacargas)
                setmunicipio(anexo.municipio)
                setnombrerazonsocial(anexo.nombrerazonsocial)
                setnombreresponsable(anexo.nombreresponsable)
                setnumeroexterior(anexo.numeroexterior)
                setnumerointerior(anexo.numerointerior)
                setopcioncontrolvariables(anexo.opcioncontrolvariables)
                setopcionproductoterminado(anexo.opcionproductoterminado)
                setotrocontrolvariables(anexo.otrocontrolvariables)
                setotroproductoterminado(anexo.otroproductoterminado)
                setpatines(anexo.patines)
                setrecipientesvidrio(anexo.recipientesvidrio)
                setreferenciascercanas(anexo.referenciascercanas)
                setse_alamientos(anexo.se_alamientos)
                settarimas(anexo.tarimas)
                settelefono(anexo.telefono)
                settipoinstalacionbodega(anexo.tipoinstalacionbodega)
                settipoinstalacionmaduracion(anexo.tipoinstalacionmaduracion)
            }
        }
    }, [])


    React.useEffect(() => {
        if (instalacionnumero === '' || instalacionnumero === undefined && anexoAlmacenEditable.length === 0) {
            setinstalacionnumero(numeroDeUnidades + 1)
        }
    }, [])
    //anexoAlmacenEditable

    const cargarDomicilioApi = async (anexo) => {
        var municipiosConClave = []
        if (anexo.estado !== '') {
            const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(anexo.estado))
            municipiosConClave = result.payload
        }
        if (anexo.municipio !== '') {
            const result = await dispatch(obtenerCPsPorMunicipioApi(anexo.municipio))
        }
        if (anexo.codigopostal !== '') {
            //anexo.codigopostal
            const result = await dispatch(obtenerColoniasPorCpApi(anexo.codigopostal))
        }
        var localidadesConClave = []
        if (anexo.codigopostal !== '') {
            const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: anexo.estado, municipio: anexo.municipio }))
            localidadesConClave = result.payload
        }
        if (anexo.localidad !== '') {
            const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, anexo.estado)
            const clave_municipio = await obtenerClaveDomicilio(municipiosConClave, anexo.municipio, "municipio")
            const clave_localidad = await obtenerClaveDomicilio(localidadesConClave, anexo.localidad, "localidad")
            const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        }
    }
    React.useEffect(() => {
        if (idEditable = props.history.location.state.idEdit === 0) {
            anexoAlmacenEditable = []
            setEditInstalacion(false)
        }
    }, [props.history.location.state])

    const [errors, setErrors] = useStateIfMounted({})
    const validarAnexo = () => {
        let errores = {}
        // instalacionnumero, alias, calle, numeroexterior, numerointerior,
        //     colonia, localidad, municipio, estado, codigopostal, referenciascercanas
        const textoError = 'Campo obligratorio'
        if (alias === '') { errores.alias = textoError }
        if (calle === '') { errores.calle = textoError }
        else if (calle === 'Otro' && otracalle === '') { errores.otracalle = textoError }

        if (numeroexterior === '') { errores.numeroexterior = textoError }
        // if (numerointerior === '') { errores.numerointerior = textoError }
        // if (colonia === '') { errores.colonia = textoError }
        if (localidad === '') { errores.localidad = textoError }
        if (municipio === '') { errores.municipio = textoError }
        if (estado === '') { errores.estado = textoError }
        if (codigopostal === '') { errores.codigopostal = textoError }
        if (referenciascercanas === '') { errores.referenciascercanas = textoError }
        setErrors(errores)
        if (JSON.stringify(errores) !== '{}') {
            return false
        }
        if (!validarResponsables()) return false
        if (!validarSecciones()) return false
        return true
    }

    const validarResponsables = () => {
        if (responsables.length === 0) return false
        for (let responsable of responsables) {
            if (responsable.nombre === '' || (responsable.telefono + '') === '' || (responsable.telefono + '').length !== 10 ||
                responsable.correoelectronico === '' || !comprobarEmail(responsable.correoelectronico)) {
                return false
            }
        }
        return true
    }
    const validarSecciones = () => {
        if (tipoinstalacionbodega) if (!validarSeccion(equipoAlmacen)) return false
        if (tipoinstalacionmaduracion) if (!validarSeccion(maduracionAlmacen)) return false
        if (tipoinstalaciongranel) if (!validarSeccion(granelAlmacen)) return false
        if (tipoinstalacionanejamiento) if (!validarSeccion(anejamientoAlmacen)) return false
        if (tipoinstalacionreposado) if (!validarSeccion(reposadoAlmacen)) return false
        if (tipoinstalacionmaduracion || tipoinstalacionanejamiento || tipoinstalacionreposado) if (!validarSeccion(variablesAlmacen)) return false

        return true
    }
    const validarSeccion = (seccion) => {
        if (seccion.length === 0) return false
        for (let anexo of seccion) {
            if (anexo.opcion === '' || (anexo.cantidad + '') === '' || anexo.descripcion === '' || anexo.otro === '') {
                return false
            }
        }
        return true
    }

    const validarDomicilio = async (data) => {
        const {
            estado,
            municipio
        } = data

        if (await validarEstadoDenominacionOrigen(estado)) return true
        if (await validarEstadoDenominacion(estado)) {
            switch (estado) {
                case 'Tamaulipas':
                    if (await validarMunicipiosTamaulipas(municipio)) return true
                    break;
                case 'Guanajuato':
                    if (await validarMunicipiosGuanajuato(municipio)) return true
                    break;
                case 'Michoacán de Ocampo':
                    if (await validarMunicipiosMichoacan(municipio)) return true
                    break;
                case 'Puebla':
                    if (await validarMunicipiosPuebla(municipio)) return true
                    break;
                default:
                    break;
            }
        }
        return false
    }

    const validarEstadoDenominacionOrigen = async (estado) => {
        if (estadosDenominacionOrigen.includes(estado)) return true
        return false
    }
    const validarEstadoDenominacion = async (estado) => {
        if (estadosDenominacion.includes(estado)) return true
        return false
    }
    const validarMunicipiosTamaulipas = async (municipio) => {
        if (municipiosTamaulipas.includes(municipio)) return true
        return false
    }
    const validarMunicipiosGuanajuato = async (municipio) => {
        if (municipiosGuanajuato.includes(municipio)) return true
        return false
    }
    const validarMunicipiosMichoacan = async (municipio) => {
        if (municipiosMichoacan.includes(municipio)) return true
        return false
    }
    const validarMunicipiosPuebla = async (municipio) => {
        if (municipiosPuebla.includes(municipio)) return true
        return false
    }

    const botonEditarAnexoAlmacen = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        const dataSeccion = {
            equipoAlmacen,
            maduracionAlmacen,
            variablesAlmacen,
            granelAlmacen,
            anejamientoAlmacen,
            reposadoAlmacen
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5,
            opcionesSeleccionadosSeccion6
        }
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = tipoinstalacionbodega ? true : await validarDomicilio(data)
        await dispatch(editarFC_01AnexoInstalacion({
            idanexo: anexoAlmacenEditable[0].data.idanexo,
            id: idEditable,
            instalacionnumero, tipoinstalacionbodega, tipoinstalacionmaduracion, tipoinstalaciongranel,
            tipoinstalacionanejamiento, tipoinstalacionreposado, alias, calle, otracalle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
            idfc01_solicitudregistro, dataSeccion, opcionesSeleccionadas, idiformaciongeneral,
            domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
            tipoInstalacion: 'Unidad Almacén'

        }))
        props.history.push('/fc_01')
    }
    const botonActualizarAnexoAlmacen = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        let datosdireccion={ idiformaciongeneral: anexoAlmacenEditable?.[0]?.data?.idiformaciongeneral,calle:calle, otracalle:otracalle, numeroexterior:numeroexterior, numerointerior:numerointerior, 
            colonia:colonia, localidad:localidad, municipio:municipio,
            estado:estado, codigopostal:codigopostal}
        await dispatch(actualizarInstalaciones({
            datosdireccion:datosdireccion,responsables:responsables
        }))
        await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc01_solicitudregistro))
        props.history.push('/fc_01')
    }

    const botonRegistrarAnexoAlmacen = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')


        const dataSeccion = {
            equipoAlmacen,
            maduracionAlmacen,
            variablesAlmacen,
            granelAlmacen,
            anejamientoAlmacen,
            reposadoAlmacen
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5,
            opcionesSeleccionadosSeccion6
        }
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'

        if (instalacionnumero > numeroDeUnidades) {
            await dispatch(actualizarFC_01NumeroDeUnidades(instalacionnumero))
        }
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = tipoinstalacionbodega ? true : await validarDomicilio(data)
        const res = await dispatch(agregarFC_01AnexoInstalacion({
            id: uuidv4(),
            instalacionnumero, tipoinstalacionbodega, tipoinstalacionmaduracion, tipoinstalaciongranel,
            tipoinstalacionanejamiento, tipoinstalacionreposado, alias, calle, otracalle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
            idfc01_solicitudregistro, dataSeccion, opcionesSeleccionadas,
            domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
            tipoInstalacion: 'Unidad Almacén'
        }))

        props.history.push('/fc_01')
    }

    const botonAgregarOtroAnexoAlmacen = async () => {
        if (anexoAlmacenEditable.length === 0) {

            telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')

            const dataSeccion = {
                equipoAlmacen,
                maduracionAlmacen,
                variablesAlmacen,
                granelAlmacen,
                anejamientoAlmacen,
                reposadoAlmacen
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5,
                opcionesSeleccionadosSeccion6
            }
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'

            if (instalacionnumero > numeroDeUnidades) {
                await dispatch(actualizarFC_01NumeroDeUnidades(instalacionnumero))
            }
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = tipoinstalacionbodega ? true : await validarDomicilio(data)
            const res = await dispatch(agregarFC_01AnexoInstalacion({
                id: uuidv4(),
                instalacionnumero, tipoinstalacionbodega, tipoinstalacionmaduracion, tipoinstalaciongranel,
                tipoinstalacionanejamiento, tipoinstalacionreposado, alias, calle, otracalle, numeroexterior,
                numerointerior, colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
                idfc01_solicitudregistro, dataSeccion, opcionesSeleccionadas,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Almacén'
            }))

            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
            const dataSeccion = {
                equipoAlmacen,
                maduracionAlmacen,
                variablesAlmacen,
                granelAlmacen,
                anejamientoAlmacen,
                reposadoAlmacen
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5,
                opcionesSeleccionadosSeccion6
            }
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = tipoinstalacionbodega ? true : await validarDomicilio(data)
            await dispatch(editarFC_01AnexoInstalacion({
                idanexo: anexoAlmacenEditable[0].data.idanexo,
                id: idEditable,
                instalacionnumero, tipoinstalacionbodega, tipoinstalacionmaduracion, tipoinstalaciongranel,
                tipoinstalacionanejamiento, tipoinstalacionreposado, alias, calle, otracalle, numeroexterior,
                numerointerior, colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
                idfc01_solicitudregistro, dataSeccion, opcionesSeleccionadas, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Almacén'

            }))
            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            idEditable = 0
            anexoAlmacenEditable = []
            setEditInstalacion(false)
            props.history.location.state.idEdit = undefined
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    //Metodos Api Copomex

    const obtenerEstadosConClave = async () => {
        const result = await dispatch(obtenerEstadosConClaveApi())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }

    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }


    const handleResetAllPropertys = () => {
        setalias('')
        setcalle('')
        setotracalle('')
        setcodigopostal('')
        setcolonia('')
        setcorreoelectronico('')
        setestado('')
        setlocalidad('')
        setmunicipio('')
        setnumeroexterior('')
        setnumerointerior('')
        setidfc01_solicitudregistro('')
        setidiformaciongeneral('')
        setreferenciascercanas('')
        settelefono('')
        settipoinstalacionbodega(false)
        settipoinstalacionmaduracion(false)
        settipoinstalaciongranel(false)
        settipoinstalacionanejamiento(false)
        settipoinstalacionreposado(false)
        setResponsables([])
        setEquipoAlmacen([])
        setMaduracionAlmacen([])
        setVariablesAlmacen([])
        setGranelAlmacen([])
        setAnejamientoAlmacen([])
        setReposadoAlmacen([])
        setOpcionesSeleccionadosSeccion1([])
        setOpcionesSeleccionadosSeccion2([])
        setOpcionesSeleccionadosSeccion3([])
        setOpcionesSeleccionadosSeccion4([])
        setOpcionesSeleccionadosSeccion5([])
        setOpcionesSeleccionadosSeccion6([])
    }

    const botonRegresarFC_01 = async () => {
        if(modoCorreccion){
            await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc01_solicitudregistro))
        }
        
        props.history.push('/fc_01')
    }

    const usarDomicilioFiscal = async () => {
        await dispatch(setMunicipiosApi(domicilioFiscal.municipiosApi))
        await dispatch(setCodigosPostalesApi(domicilioFiscal.codigosPostalesApi))
        await dispatch(setColoniasApi(domicilioFiscal.coloniasApi))
        await dispatch(setLocalidadesApi(domicilioFiscal.localidadesApi))
        await dispatch(setCallesApi(domicilioFiscal.callesApi))

        setcalle(domicilioFiscal.calle)
        setotracalle(domicilioFiscal.otracalle)
        setcodigopostal(domicilioFiscal.codigopostal)
        setcolonia(domicilioFiscal.colonia)
        setestado(domicilioFiscal.estado)
        setlocalidad(domicilioFiscal.localidad)
        setmunicipio(domicilioFiscal.municipioalcaldia)
        setnumeroexterior(domicilioFiscal.numeroexterior)
        setnumerointerior(domicilioFiscal.numerointerior)
    }

    const validateEmail = (event) => {

        const email = event.target.value;
        comprobarEmail(email);

    };

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;

        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }

    }
    return (
        <Fragment>
            <div className='container containerFixed'>
                <div className='row ms-1 mt-1'>
                    <div className='row justify-content-start mb-2'>
                        <div className={`${estilos.botonRegresar} col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-4`}>
                            <button
                                onClick={botonRegresarFC_01}
                                className='btn btnNaranja zoom-in-zoom-out'>Regresar
                            </button>
                        </div>
                        <div className='col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mt-3'>
                            {
                                !modoCorreccion &&
                                    !editInstalacion ?
                                    (
                                        <h2 className='ms-4'>Unidad de Almacén</h2>) :
                                    (

                                        <h4><strong>Editando</strong> Unidad de Almacén</h4>
                                    )
                            }
                        </div>

                    </div>

                    <div className='row justify-content-start'>
                        <div className={`${estilos.labelNaranjaInstalacion} row text-center mb-2`} >
                            <h5 className=' mt-2 mb-2 '>Tipo de instalación</h5>
                        </div>
                        <small className='text-center'><b>Nota:</b> Podrá seleccionar más de un tipo de instalación siempre y cuando estén en el mismo domicilio.</small>
                        <div className='row mt-2'>
                            <div className="input-group mb-3 justify-content-center">
                                {/* <label >Tipo de instalación </label> */}
                                <input
                                    checked={tipoinstalacionbodega}
                                    onChange={e => settipoinstalacionbodega(e.target.checked)}
                                    className={`form-check-input me-2 ms-2 ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                    type="checkbox"
                                    value={tipoinstalacionbodega} id="bodega"
                                    disabled={!dataFC_01.comercializadormezcal && !dataFC_01.comercializadorbebidasconmezcal}
                                />
                                <h6 className='textoNormal'>Producto terminado</h6>
                                <span className='text-danger'>{anexoMap?.tipoinstalacionbodega}</span>

                                <input
                                    checked={tipoinstalaciongranel}
                                    onChange={e => settipoinstalaciongranel(e.target.checked)}
                                    className={`form-check-input me-2 ms-4 ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                    type="checkbox" value={tipoinstalaciongranel} id="granel"
                                    disabled={!dataFC_01.productormezcal && !dataFC_01.envasador}
                                />
                                <h6 className='textoNormal'>Graneles</h6>

                                <input
                                    checked={tipoinstalacionmaduracion}
                                    onChange={e => settipoinstalacionmaduracion(e.target.checked)}
                                    className={`form-check-input me-2 ms-4 ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                    type="checkbox" value={tipoinstalacionmaduracion} id="maduracion"
                                    disabled={!dataFC_01.productormezcal && !dataFC_01.envasador}
                                />
                                <h6 className='textoNormal'>Maduración de producto</h6>
                                <span className='text-danger'>{anexoMap?.tipoinstalacionmaduracion}</span>

                                {/* <input
                                    checked={tipoinstalacionanejamiento}
                                    onChange={e => settipoinstalacionanejamiento(e.target.checked)}
                                    className={`form-check-input me-2 ms-4 ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                    type="checkbox" value={tipoinstalacionanejamiento} id="añejamiento"
                                    disabled={!dataFC_01.productormezcal && !dataFC_01.envasador}
                                />
                                <h6 className='textoNormal'>Añejamiento de productos</h6>

                                <input
                                    checked={tipoinstalacionreposado}
                                    onChange={e => settipoinstalacionreposado(e.target.checked)}
                                    className={`form-check-input me-2 ms-4 ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                    type="checkbox" value={tipoinstalacionreposado} id="reposado"
                                    disabled={!dataFC_01.productormezcal && !dataFC_01.envasador}
                                />
                                <h6 className='textoNormal'>Reposado de productos</h6> */}
                            </div>
                        </div>
                        {
                            (tipoinstalacionbodega || tipoinstalaciongranel || tipoinstalacionmaduracion) &&
                            <div className='row justify-content-start'>
                                <div className={`${estilos.labelNaranjaInstalacion} row mb-2`}>
                                    <div className='col-md-8'>
                                        <h5 className='text-end'>Información de la instalación</h5>
                                    </div>
                                    <div className='col-md-4 text-end'>
                                        <Tooltip title="Usar el domicilio fiscal sí la instalación se encuentra ubicada en el mismo domicilio." arrow>
                                            <button onClick={e => usarDomicilioFiscal()} className="btn btnNaranja zoom-in-zoom-out">
                                                Usar domicilio fiscal
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                                {/* <div className='row mb-3'>
                            <h6 className='text-center me-5'>¿La instalación se encuentra ubicada en el mismo domicilio fiscal?
                                <label className="ms-5 ">Si:</label>
                                <Tooltip title="Aqui va el mensaje" arrow>
                                    <input className={`ms-2 form-check-input`}
                                        type="checkbox"
                                        checked={false} id="si" />
                                </Tooltip>
                                <label className="ms-5 ">No:</label>
                                <input className={`ms-2 form-check-input`}
                                    type="checkbox"
                                    checked={false} id="no" />
                            </h6>
                        </div> */}
                                <div className='col-md-3'>

                                    <div className="form-floating mb-3">
                                        <input
                                            value={instalacionnumero} onChange={e => setinstalacionnumero(Number(e.target.value))}
                                            type="number"
                                            className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                            id="" placeholder='Número de instalción' disabled
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                        <label className='floatingInput'>Número de instalación </label>
                                        <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                    </div>
                                </div>
                                <div className='col-md-9'>
                                    <div className="form-floating mb-3">
                                        <input
                                            value={alias}
                                            onChange={e => setalias(e.target.value)}
                                            type="text"
                                            className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                            id="" placeholder='Nombre de la instalacion'
                                            onBlur={validarAnexo}
                                        />
                                        {errors.alias && <div className="text-danger">{errors.alias}</div>}
                                        <label className='floatingInput'>Alias: <i>(Asignar un "Alias" para identificar cada instalación, esto permitirá diferenciarlas)</i></label>
                                        <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                    </div>
                                </div>
                                {/* <div className='divRedondeadoNaranja'>
                            <h5 className='text-center labelNaranja mt-3'>Domicilio de la instalación</h5>
                        </div> */}

                                {/* <div className='col-md-6'>

                                    <div className="form-floating mb-3">
                                        <input
                                            value={telefono} onChange={e => e.target.value.length < 11 ? (settelefono(e.target.value)) : ''}
                                            type="number"
                                            className={`form-control ${anexoMap?.telefonocheck !== undefined ? (
                                                anexoMap?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')
                                                }`}
                                            id="" placeholder='Teléfono'
                                        />
                                        <label className="floatingInput">Teléfono del responsable</label>
                                        <span className='text-danger'>{anexoMap?.telefono}</span>
                                    </div>
                                </div>
                                <div className='col-md-6'>

                                    <div className="form-floating mb-3">
                                        <input
                                            value={correoelectronico}
                                            onChange={e => {
                                                setcorreoelectronico(e.target.value);
                                                validateEmail(e);
                                            }}
                                            type="email"
                                            className={`form-control ${anexoMap?.correoelectronicocheck !== undefined ? (
                                                anexoMap?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')
                                                }`}
                                            id="" placeholder='ejemplo@gmail.com' />
                                        <span className='text-danger'>{anexoMap?.correoelectronico}</span>
                                        <label className="floatingInput">Correo electrónico del responsable</label>
                                        <div className={`message ${isValid ? estilos.success : estilos.error}`}>
                                            {message}
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row justify-content-start'>
                                    {/* <div className='divRedondeadoNaranja'>
                            <h6 className='text-center'>DOMICILIO DE LA INSTALACIÓN</h6>
                        </div> */}
                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={estado} onChange={e => setestado(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Estado'
                                    onBlur={validarAnexo} /> */}
                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={estado}
                                                onChange={e => {
                                                    setestado(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.estado = e.target.value
                                                    setmunicipio('')
                                                    setcodigopostal('')
                                                    setcolonia('')
                                                    setlocalidad('')
                                                    setcalle('')
                                                    if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)
                                                    // setValues(newValues)

                                                }}
                                                name="estado"
                                                onBlur={validarAnexo}
                                            >
                                                <option value="">Seleccione su estado</option>
                                                {
                                                    estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                                        <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>
                                                    ))
                                                }
                                            </select>


                                            {errors.estado && <div className="text-danger">{errors.estado}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Estado</label>
                                        </div>
                                    </div>


                                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={municipio} onChange={e => setmunicipio(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Delegación/Municipio'
                                    onBlur={validarAnexo} /> */}
                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={municipio}
                                                onChange={e => {
                                                    setmunicipio(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.municipioalcaldia = e.target.value
                                                    setcodigopostal('')
                                                    setcolonia('')
                                                    setlocalidad('')
                                                    setcalle('')
                                                    if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                                    // setValues(newValues)
                                                }}
                                                name="municipio"
                                                onBlur={validarAnexo}
                                                disabled={estado === '' ? true : false}
                                            >
                                                <option value="">Seleccione su municipio</option>
                                                {
                                                    municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                                        <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                                    ))
                                                }
                                            </select>

                                            {errors.municipio && <div className="text-danger">{errors.municipio}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Delegación/Municipio</label>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={codigopostal} onChange={e => setcodigopostal(e.target.value)}
                                    type="number" min='0'
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Código Postal'
                                    onBlur={validarAnexo} /> */}

                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={codigopostal}
                                                onChange={e => {
                                                    setcodigopostal(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.codigopostal = e.target.value
                                                    setcolonia('')
                                                    setlocalidad('')
                                                    setcalle('')
                                                    if (e.target.value !== '') obtenerColonias(e.target.value)
                                                    if (e.target.value !== '') obtenerLocalidades({ estado: estado, municipio: municipio })
                                                    // setValues(newValues)
                                                }}
                                                name="codigopostal"
                                                onBlur={validarAnexo}
                                                disabled={municipio === '' ? true : false}
                                            >
                                                <option value="">Seleccione su código postal</option>
                                                {
                                                    codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                                        <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                                    ))
                                                }
                                            </select>
                                            {errors.codigopostal && <div className="text-danger">{errors.codigopostal}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Código Postal</label>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={colonia} onChange={e => setcolonia(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Colonia'
                                    onBlur={validarAnexo} /> */}

                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={colonia}
                                                onChange={e => {
                                                    setcolonia(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.colonia = e.target.value
                                                    // setValues(newValues)
                                                }}
                                                name="colonia"
                                                onBlur={validarAnexo}
                                                disabled={codigopostal === '' ? true : false}
                                            >
                                                <option value="">Seleccione su colonia</option>
                                                {
                                                    coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                                        <option key={index} value={`${colonia}`}>{`${colonia}`}</option>
                                                    ))
                                                }
                                            </select>
                                            {errors.colonia && <div className="text-danger">{errors.colonia}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Colonia</label>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={localidad} onChange={e => setlocalidad(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Localidad'
                                    onBlur={validarAnexo} /> */}

                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={localidad}
                                                onChange={e => {
                                                    setlocalidad(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.localidad = e.target.value
                                                    setcalle('')
                                                    if (e.target.value !== '') obtenerCalles({ clave_estado: estado, clave_municipio: municipio, clave_localidad: localidad })

                                                    // setValues(newValues)
                                                }}
                                                name="localidad"
                                                onBlur={validarAnexo}
                                                disabled={codigopostal === '' ? true : false}
                                            >
                                                <option value="">Seleccione su localidad</option>
                                                {
                                                    localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                                        <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                                    ))
                                                }
                                            </select>
                                            {errors.localidad && <div className="text-danger">{errors.localidad}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Localidad</label>
                                        </div>
                                    </div>
                                    <div className={`col-xs-12 col-sm-12 ${calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1 col-xxl-1' : 'col-md-6 col-lg-6 col-xl-6 col-xxl-6'}`}>
                                        <div className="form-floating mb-3">
                                            {/* <input
                                    value={calle} onChange={e => setcalle(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap.domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Calle'
                                    onBlur={validarAnexo} /> */}

                                            <select className={`form-control ${anexoMap.length > 0 ? (anexoMap.domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                value={calle}
                                                onChange={e => {
                                                    setcalle(e.target.value)
                                                    // const { ...newValues } = values
                                                    // newValues.calle = e.target.value
                                                    // setValues(newValues)
                                                }}
                                                name="calle"
                                                onBlur={validarAnexo}
                                                disabled={localidad === '' ? true : false}
                                            >
                                                <option value="">Seleccione su calle</option>
                                                {
                                                    callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                                        <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                                    ))
                                                }
                                                <option value="Otro">Otro</option>
                                            </select>
                                            {errors.calle && <div className="text-danger">{errors.calle}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Calle</label>
                                        </div>
                                    </div>
                                    {
                                        calle === 'Otro' &&
                                        <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput"
                                                    // onChange={e => setNumExterior(e.target.value)}
                                                    //     value={numeroexterior}
                                                    className={`form-control ${anexoMap.length > 0 ? (anexoMap.domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    placeholder='Calle'
                                                    name="otracalle"
                                                    value={otracalle}
                                                    onChange={e => setotracalle(e.target.value)}
                                                    onBlur={validarAnexo}
                                                />
                                                {errors.otracalle && <div className="text-danger">{errors.otracalle}</div>}
                                                <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                                <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                                            </div>
                                        </div>
                                    }
                                    <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                        <div className="form-floating mb-3">
                                            <input
                                                value={numeroexterior} onChange={e => setnumeroexterior(e.target.value)}
                                                type="text" min='0'
                                                className={`form-control ${anexoMap?.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                id="" placeholder='Número exterior'
                                                onBlur={validarAnexo} />
                                            {errors.numeroexterior && <div className="text-danger">{errors.numeroexterior}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Número exterior</label>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                        <div className="form-floating mb-3">
                                            <input
                                                value={numerointerior} onChange={e => setnumerointerior(e.target.value)}
                                                type="text" min='0'
                                                className={`form-control ${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                id="" placeholder='Número interior'
                                                onBlur={validarAnexo} />
                                            {errors.numerointerior && <div className="text-danger">{errors.numerointerior}</div>}
                                            <span className={`${anexoMap.length > 0 ? (anexoMap[0].domiciliocheck === true ? 'text-danger' : 'text-success') : ('')}`}>{anexoMap[0]?.domiciliocheck === true ? (anexoMap[0]?.domicilio) : ''}</span>
                                            <label className="floatingInput">Numero interior</label>
                                        </div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <input
                                                value={referenciascercanas} onChange={e => setreferenciascercanas(e.target.value)}
                                                type="text" min='0'
                                                className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                id="" placeholder='Indique los lugares cercanos que permitan localizar con facilidad sus instalaciones, o las calles entre las que se encuentra.'
                                                onBlur={validarAnexo} />
                                            {errors.referenciascercanas && <div className="text-danger">{errors.referenciascercanas}</div>}
                                            <label className="floatingInput">Referencias cercanas</label>
                                            {/* <span className={`${anexoMap.length>0?(anexoMap[0].domiciliocheck===true? 'text-danger':'text-success') :('')}`}>{anexoMap?.domicilio}</span> */}
                                        </div>
                                    </div>
                                </div>
                                <div className='divRedondeadoNaranja'>
                                    <h5 className={`text-center  ${estilos.labelNaranjaInstalacion} mt-3`}>Responsables de la instalación</h5>
                                </div>
                                {
                                    responsables.map((inputField, index) => (
                                        <div key={index} className='row'>
                                            <div className='col-md-4'>
                                                <div className="form-floating mb-3">
                                                    <input type="text"
                                                        className={`form-control ${anexoResponsablesMap?.filter(map => map?.idresponsabledeinstalacion
                                                            === inputField.idresponsabledeinstalacion)[0]?.nombreresponsablecheck !== undefined ? (anexoResponsablesMap?.filter
                                                                (map => map.idresponsabledeinstalacion === inputField.idresponsabledeinstalacion)[0]?.nombreresponsablecheck ?
                                                                'inputDenegado' : 'inputValidado') : ('')} `}
                                                        onChange={e =>
                                                            handleOnChangueResponsable(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: inputField.id,
                                                                    campo: 'nombreresponsable'
                                                                })}
                                                        value={inputField.nombreresponsable}
                                                        id="" placeholder='Nombre del responsable'
                                                    />
                                                    {inputField.nombreresponsable.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Nombre completo del responsable</label>
                                                    <span className={`${anexoResponsablesMap?.filter(map => map.idresponsabledeinstalacion === inputField.idresponsabledeinstalacion)[0]?.nombreresponsablecheck !== undefined ? (
                                                        anexoResponsablesMap?.filter(map => map.idresponsabledeinstalacion === inputField.idresponsabledeinstalacion)[0]?.nombreresponsablecheck ? 'text-danger'
                                                            : 'text-success') : ('')}`}>{anexoResponsablesMap?.filter(map => map.idresponsabledeinstalacion
                                                                === inputField.idresponsabledeinstalacion)[0]?.nombreresponsablecheck ? (anexoResponsablesMap?.filter(map => map.idresponsabledeinstalacion
                                                                    === inputField.idresponsabledeinstalacion)[0]?.nombreresponsable) : ''}</span>
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                                <div className="form-floating mb-3">
                                                    <input type="number"
                                                        className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => e.target.value.length < 11 ? (
                                                            handleOnChangueResponsable(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: inputField.id,
                                                                    campo: 'telefono'
                                                                })) : ''}
                                                        value={inputField.telefono}
                                                        id="" placeholder='Telefono'
                                                        onWheel={event => event.currentTarget.blur()}
                                                    />
                                                    {inputField.telefono.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : inputField.telefono.length !== 10 ? (<span className='text-danger'>Debe contener 10 digitos</span>) : ''}
                                                    <label className="floatingInput">Teléfono</label>
                                                    {/* <span
                                            className='text-danger'>{personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                === inputField.idfc01_anexopersonaatorizadatramites)[0]?.telefonopersona}</span> */}
                                                </div>

                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                                <div className="form-floating mb-3">
                                                    <input type="email"
                                                        className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e =>
                                                            handleOnChangueResponsable(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: inputField.id,
                                                                    campo: 'correoelectronico'
                                                                })
                                                        }
                                                        value={inputField.correoelectronico}
                                                        id="" placeholder='Correo'
                                                    />
                                                    <label className="floatingInput">Correo electrónico</label>
                                                    {
                                                        inputField.correoelectronico === '' ?
                                                            <div className={`message text-danger`}>
                                                                Campo obligatorio
                                                            </div>
                                                            :
                                                            <div key={index} className={`message ${(inputField.estado) ? estilos.success : estilos.error}`}>
                                                                {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                            </div>
                                                    }
                                                    {/* <span
                                            className='text-danger'>{personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                === inputField.idfc01_anexopersonaatorizadatramites)[0]?.correoelectronicopersona}</span> */}
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                (
                                                    <div className='col-md-1'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteResponsable(inputField)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteResponsable, inputField }} text="un responsable de instalción" />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                                {
                                    !modoCorreccion &&
                                    (
                                        <div className='row justify-content-start'>
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarAnexo col-md-3' onClick={e =>
                                                    handleAddResponsable()}>Agregar responsable</button>
                                                {responsables.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        </div>
                                    )
                                }

                                <div className='divRedondeadoNaranja'>
                                    <h4 className={`text-center ${estilos.labelNaranjaInstalacion}`}>Descripción de la instalación</h4>
                                </div>

                            </div>
                        }


                        {/* <div className='col-md-12'>
                            <div className="form-floating mb-3">
                                <input
                                    value={nombreresponsable} onChange={e => setnombreresponsable(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap?.nombreresponsablecheck !== undefined ? (
                                        anexoMap?.nombreresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')
                                        }`}
                                    id="" placeholder='Nombre del responsable'
                                />
                                <label className="floatingInput">Nombre del responsable</label>
                                <span className='text-danger'>{anexoMap?.nombreresponsable}</span>
                            </div>
                        </div> */}
                    </div>

                    {/* <div className='container'> */}
                    {
                        seccionesAlmacen.map((inputField, index) => (
                            <div key={index} className='row'>
                                <div className={`text-center ${estilos.labelAlmacen} ms-3 me-3`}>
                                    {
                                        (index === 0 && tipoinstalacionbodega) &&
                                        <h3 className={`text-center ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    }
                                    {
                                        (index === 1 && tipoinstalaciongranel) &&
                                        <h3 className={`text-center ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    }
                                    {
                                        (index === 2 && tipoinstalacionmaduracion) &&
                                        <h3 className={`text-center mt-2 ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    }
                                    {/* {
                                        (index === 3 && tipoinstalacionanejamiento) &&
                                        <h3 className={`text-center mt-2 ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    }
                                    {
                                        (index === 4 && tipoinstalacionreposado) &&
                                        <h3 className={`text-center mt-2 ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    } */}
                                    {
                                        (index === 3 && (tipoinstalacionmaduracion)) &&
                                        <h3 className={`text-center mt-2 ${estilos.labelAlmacen}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    }

                                </div>

                                {
                                    (index === 0 && tipoinstalacionbodega) &&

                                    equipoAlmacen.map((equipoAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`${equipoAlmacen.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                <div className="form-floating mb-3">
                                                    <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        value={equipoAlmacen.opcion}
                                                        onChange={e => handleOnChangueEquipoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: equipoAlmacen.id,
                                                                campo: 'opcion',
                                                                seccion: inputField
                                                            })}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {
                                                            inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                ((opcionesSeleccionadosSeccion1.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                //disabled 
                                                                >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {equipoAlmacen.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Equipo</label>
                                                </div>

                                            </div>
                                            {
                                                equipoAlmacen.opcion === 'Otro' &&
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueEquipoAlmacen(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: equipoAlmacen.id,
                                                                    campo: 'otro'
                                                                })}
                                                            placeholder='0'
                                                            value={equipoAlmacen.otro}
                                                            id="" />
                                                        {(equipoAlmacen.otro === '' || equipoAlmacen.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Especifique</label>
                                                    </div>
                                                </div>
                                            }
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueEquipoAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: equipoAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={equipoAlmacen.cantidad}
                                                        id=""
                                                        disabled={equipoAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {equipoAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueEquipoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: equipoAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='0'
                                                        value={equipoAlmacen.descripcion}
                                                        id=""
                                                        disabled={equipoAlmacen.opcion === '' ? true : false} />
                                                    {equipoAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Caracteristicas</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'>
                                                    {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteEquipoAlmacen(equipoAlmacen)}>Eliminar</button> */}
                                                    <ModalComponent api={{ deleteAnexo: deleteEquipoAlmacen, inputField: equipoAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>

                                    ))
                                }

                                {
                                    (index === 1 && tipoinstalaciongranel) &&

                                    granelAlmacen.map((granelAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`${granelAlmacen.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                <div className="form-floating mb-3">
                                                    <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        value={granelAlmacen.opcion}
                                                        onChange={e => handleOnChangueGranelAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: granelAlmacen.id,
                                                                campo: 'opcion',
                                                                seccion: inputField
                                                            })}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {
                                                            inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                ((opcionesSeleccionadosSeccion4.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                //disabled 
                                                                >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {granelAlmacen.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Opción</label>
                                                </div>

                                            </div>
                                            {
                                                granelAlmacen.opcion === 'Otro' &&
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueGranelAlmacen(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: granelAlmacen.id,
                                                                    campo: 'otro'
                                                                })}
                                                            placeholder='0'
                                                            value={granelAlmacen.otro}
                                                            id="" />
                                                        {(granelAlmacen.otro === '' || granelAlmacen.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Especifique</label>
                                                    </div>
                                                </div>
                                            }
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueGranelAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: granelAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={granelAlmacen.cantidad}
                                                        id=""
                                                        disabled={granelAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {granelAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueGranelAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: granelAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='0'
                                                        value={granelAlmacen.descripcion}
                                                        id=""
                                                        disabled={granelAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {granelAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Capacidad (Litros)</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'>
                                                    {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteGranelAlmacen(granelAlmacen)}>Eliminar</button> */}
                                                    <ModalComponent api={{ deleteAnexo: deleteGranelAlmacen, inputField: granelAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>

                                    ))
                                }
                                {
                                    (index === 2 && tipoinstalacionmaduracion) &&
                                    maduracionAlmacen.map((maduracionAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`col-md-5`}>
                                                <div className="form-floating mb-3">
                                                    <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        value={maduracionAlmacen.opcion}
                                                        onChange={e => handleOnChangueMaduracionAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: maduracionAlmacen.id,
                                                                campo: 'opcion',
                                                                seccion: inputField
                                                            })}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {
                                                            inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                ((opcionesSeleccionadosSeccion2.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                //disabled 
                                                                >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {/* <input type="text" className={`form-control`}
                                                        onChange={e => handleOnChangueMaduracionAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: maduracionAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='0'
                                                        value={maduracionAlmacen.opcion}
                                                        id=""
                                                        disabled
                                                    /> */}
                                                    {/* <label className="floatingInput">Opción</label> */}
                                                </div>

                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueMaduracionAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: maduracionAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={maduracionAlmacen.cantidad}
                                                        id=""
                                                        disabled={maduracionAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {maduracionAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueMaduracionAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: maduracionAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='0'
                                                        value={maduracionAlmacen.descripcion}
                                                        id=""
                                                        disabled={maduracionAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {maduracionAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Capacidad (Litros)</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'>
                                                    {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteMaduracionAlmacen(maduracionAlmacen)}>Eliminar</button> */}
                                                    <ModalComponent api={{ deleteAnexo: deleteMaduracionAlmacen, inputField: maduracionAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>
                                    ))
                                }
                                {/* {
                                    (index === 3 && tipoinstalacionanejamiento) &&
                                    anejamientoAlmacen.map((anejamientoAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`col-md-5`}>
                                                <div className="form-floating mb-3"> */}
                                {/* <select className={`form-select`}
                                                            value={anejamientoAlmacen.opcion}
                                                            onChange={e => handleOnChangueAnejamientoAlmacen(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: anejamientoAlmacen.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion5.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option value={`${opcion.elemento.nombreelemento}`} disabled >{`${opcion.elemento.nombreelemento}`}</option> : <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <label className="floatingInput">Opción</label> */}
                                {/* <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueAnejamientoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: anejamientoAlmacen.id,
                                                                campo: 'opcion'
                                                            })}
                                                        placeholder='0'
                                                        value={anejamientoAlmacen.opcion}
                                                        id=""
                                                        disabled
                                                    /> */}
                                {/* <label className="floatingInput">Opción</label> */}
                                {/* </div>

                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueAnejamientoAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: anejamientoAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={anejamientoAlmacen.cantidad}
                                                        id=""
                                                    />
                                                    {anejamientoAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueAnejamientoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: anejamientoAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='caracteristicas'
                                                        value={anejamientoAlmacen.descripcion}
                                                        id=""
                                                    />
                                                    {anejamientoAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Capacidad (Litros)</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'> */}
                                {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteAnejamientoAlmacen(anejamientoAlmacen)}>Eliminar</button> */}
                                {/* <ModalComponent api={{ deleteAnexo: deleteAnejamientoAlmacen, inputField: anejamientoAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>

                                    ))
                                } */}
                                {/* {
                                    (index === 4 && tipoinstalacionreposado) &&
                                    reposadoAlmacen.map((reposadoAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`col-md-5 `}>
                                                <div className="form-floating mb-3"> */}
                                {/* <select className={`form-select`}
                                                            value={anejamientoAlmacen.opcion}
                                                            onChange={e => handleOnChangueAnejamientoAlmacen(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: anejamientoAlmacen.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion5.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option value={`${opcion.elemento.nombreelemento}`} disabled >{`${opcion.elemento.nombreelemento}`}</option> : <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <label className="floatingInput">Opción</label> */}
                                {/* <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueReposadoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: reposadoAlmacen.id,
                                                                campo: 'opcion'
                                                            })}
                                                        placeholder='0'
                                                        value={reposadoAlmacen.opcion}
                                                        id=""
                                                        disabled
                                                    /> */}
                                {/* <label className="floatingInput">Opción</label> */}
                                {/* </div>

                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueReposadoAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: reposadoAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={reposadoAlmacen.cantidad}
                                                        id=""
                                                    />
                                                    {reposadoAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueReposadoAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: reposadoAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='caracteristicas'
                                                        value={reposadoAlmacen.descripcion}
                                                        id=""
                                                    />
                                                    {reposadoAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Capacidad (Litros)</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'> */}
                                {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteAnejamientoAlmacen(anejamientoAlmacen)}>Eliminar</button> */}
                                {/* <ModalComponent api={{ deleteAnexo: deleteReposadoAlmacen, inputField: reposadoAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>

                                    ))
                                } */}
                                {
                                    (index === 3 && (tipoinstalacionmaduracion)) &&
                                    variablesAlmacen.map((variablesAlmacen, indexEquipo) => (
                                        <div className='row'>
                                            <div className={`${variablesAlmacen.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                <div className="form-floating mb-3">
                                                    <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        value={variablesAlmacen.opcion}
                                                        onChange={e => handleOnChangueVariablesAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: variablesAlmacen.id,
                                                                campo: 'opcion',
                                                                seccion: inputField
                                                            })}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {
                                                            inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                ((opcionesSeleccionadosSeccion3.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                //disabled 
                                                                >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {variablesAlmacen.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Opción</label>
                                                </div>

                                            </div>
                                            {
                                                variablesAlmacen.opcion === 'Otro' &&
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueVariablesAlmacen(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: variablesAlmacen.id,
                                                                    campo: 'otro'
                                                                })}
                                                            placeholder='0'
                                                            value={variablesAlmacen.otro}
                                                            id="" />
                                                        {(variablesAlmacen.otro === '' || variablesAlmacen.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Especifique</label>
                                                    </div>
                                                </div>
                                            }
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="number" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueVariablesAlmacen(
                                                            {
                                                                valor: Number(e.target.value),
                                                                id: variablesAlmacen.id,
                                                                campo: 'cantidad'
                                                            })}
                                                        placeholder='0'
                                                        value={variablesAlmacen.cantidad}
                                                        id=""
                                                        disabled={variablesAlmacen.opcion === '' ? true : false}
                                                        onWheel={event => event.currentTarget.blur()} />
                                                    {variablesAlmacen.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Cantidad</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3'>
                                                <div className="form-floating mb-2">
                                                    <input type="text" className={`form-control ${anexoMap.length > 0 ? 'inputValidado' : ''}`}
                                                        onChange={e => handleOnChangueVariablesAlmacen(
                                                            {
                                                                valor: e.target.value,
                                                                id: variablesAlmacen.id,
                                                                campo: 'descripcion'
                                                            })}
                                                        placeholder='caracteristicas'
                                                        value={variablesAlmacen.descripcion}
                                                        id=""
                                                        disabled={variablesAlmacen.opcion === '' ? true : false} />
                                                    {variablesAlmacen.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                    <label className="floatingInput">Características</label>
                                                </div>
                                            </div>
                                            {
                                                !modoCorreccion &&
                                                <div className='mt-2 col-md-1 border-secondary'>
                                                    {/* <button className='btn btn-danger' onClick={e =>
                                                        deleteVariablesAlmacen(variablesAlmacen)}>Eliminar</button> */}
                                                    <ModalComponent api={{ deleteAnexo: deleteVariablesAlmacen, inputField: variablesAlmacen }} text="un elemento" />
                                                </div>
                                            }
                                        </div>

                                    ))
                                }

                                <div className='container'>
                                    {
                                        (index === 0 && tipoinstalacionbodega && !modoCorreccion) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddEquipoAlmacen()}>Agregar</button>
                                            <br />
                                            {equipoAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    }
                                    {
                                        (index === 1 && tipoinstalaciongranel && !modoCorreccion) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddGranelAlmacen()}>Agregar</button>
                                            <br />
                                            {granelAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    }
                                    {
                                        (index === 2 && tipoinstalacionmaduracion && !modoCorreccion) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddMaduracionAlmacen({ seccion: inputField })}>Agregar</button>
                                            <br />
                                            {maduracionAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    }
                                    {/* {
                                        (index === 3 && tipoinstalacionanejamiento && !modoCorreccion && anejamientoAlmacen.length === 0) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddAnejamientoAlmacen({ seccion: inputField })}>Agregar</button>
                                            <br />
                                            {anejamientoAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    }
                                    {
                                        (index === 4 && tipoinstalacionreposado && !modoCorreccion && reposadoAlmacen.length === 0) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddReposadoAlmacen({ seccion: inputField })}>Agregar</button>
                                            <br />
                                            {reposadoAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    } */}
                                    {
                                        (index === 3 && (tipoinstalacionmaduracion || tipoinstalacionanejamiento || tipoinstalacionreposado) && !modoCorreccion) &&
                                        <div className='mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarElementoAlmacen col-md-1 mb-1' onClick={e =>
                                                handleAddVariablesAlmacen()}>Agregar</button>
                                            <br />
                                            {variablesAlmacen.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            <hr />
                                        </div>
                                    }
                                </div>

                            </div>
                        ))
                    }
                    <br />
                </div>
                <div className="row mt-5">
                    <br />
                    <br />
                    {
                        anexoAlmacenEditable.length === 0 &&
                        <div className={`text-center ${estilos.botonGuardarAlmacen}`}>
                            {
                                (tipoinstalacionbodega || tipoinstalaciongranel || tipoinstalacionmaduracion) &&
                                <GuardarInstalacionComponent
                                    guardarInstacion={botonRegistrarAnexoAlmacen}
                                    agregarOtraInstalacion={botonAgregarOtroAnexoAlmacen}
                                    unidad={'almacén'}
                                    validarUnidad={validarAnexo}
                                    texto={'Guardar'}
                                />
                            }

                        </div>

                    }
                    {
                        anexoAlmacenEditable.length > 0 &&
                        <div className='text-center'>

                            {
                                !modoCorreccion ?
                                    <GuardarInstalacionComponent
                                        guardarInstacion={botonEditarAnexoAlmacen}
                                        agregarOtraInstalacion={botonAgregarOtroAnexoAlmacen}
                                        unidad={'almacén'}
                                        validarUnidad={validarAnexo}
                                        texto={'Guardar cambios'}
                                    />
                                    :
                                    <button
                                        onClick={() => botonActualizarAnexoAlmacen()}
                                        type='submit'
                                        className={`btn btnNaranja`}
                                        disabled={!tipoinstalacionbodega && !tipoinstalaciongranel && !tipoinstalacionmaduracion}> Guardar cambios
                                    </button>
                            }
                        </div>

                    }
                </div>
            </div>
        </Fragment >
    )
}

export default withRouter(FormularioFC01AnexoAlmacenBeneficiarioComponent)
